import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wh_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      if (!window.location.pathname.startsWith("/login")) {
        localStorage.removeItem("wh_token");
        localStorage.removeItem("wh_user");
        window.location.replace("/login");
      }
    }
    return Promise.reject(err);
  }
);
